import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Grid, Divider } from '@mui/material';
import InputControl from '../../Components/Common/TextField/TextField';
import CustomButton from '../../Components/Button/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteEntity, V_GetAllEntitiesBase } from '../../Reducers/dcoi';
import Pagination from '@mui/material/Pagination';
import ConfirmationModel from '../../Components/Common/DeleteModel/DeleteModel';
import Spinner from '../../Components/Common/Spinner/Spinner';
import CheckIcon from '@mui/icons-material/Check';
import Toster from '../../Components/Common/Toster/Toster';

function ManageEntity() {
  const { V_entityListBase, inProgress } = useSelector((state) => state.dcoi);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(V_GetAllEntitiesBase());
  }, [dispatch]);
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState();
  const [severity, setSavirity] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteModel, setDeleteModel] = useState(false);
  const [itemID, setItemID] = useState()
  const [filteredItems, setFilteredItems] = useState(V_entityListBase);  // Store filtered items
  const itemsPerPage = 20;

  useEffect(() => {
    if (V_entityListBase?.length > 0) {
      setFilteredItems(V_entityListBase); // Update filteredItems with the fetched data
    }
  }, [V_entityListBase]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearchChange = (e) => {
    if (e !== undefined) {
      setSearchQuery(e);
    }
  };

  const handleSearchClick = () => {
    const filteredData = V_entityListBase.filter((item) =>
      item?.EntityName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.EntityDescription?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredItems(filteredData); // Update the filtered items state
    setCurrentPage(1); // Reset pagination to the first page
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);  // Fix pagination to use filteredItems


  const SucessDelete = () => {
    dispatch(DeleteEntity({ entityId: itemID })).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setSavirity("success");
        setMessage(res?.payload?.data[0]?.success)
        setDeleteModel(!deleteModel);
        dispatch(V_GetAllEntitiesBase());
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.error)
        setSavirity("error");
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSavirity("error");
      }
    })
  }


  return (
    <>
     <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <ConfirmationModel open={deleteModel} handleOpen={() => setDeleteModel(!deleteModel)} SucessDelete={SucessDelete} />
      <div className='headerNavigation'>
        <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>List of Entities</Typography>
        <div></div>
      </div>

      <Box className='boxAlignment'>
        <Grid container spacing={2} alignItems='center' justifyContent='space-between'>
          <Grid item xs={12} sm={8} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Box sx={{ flexGrow: 1 }}>
                <InputControl
                  type='text'
                  placeholder='Search by HFM Code or Entity Name'
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </Box>
              <Button
                sx={{ backgroundColor: " #212129", color: "white", padding: "8px", borderRadius: "0px" }}
                startIcon={<SearchIcon className='actionIcon' />}
                onClick={handleSearchClick} // Trigger search functionality on button click
              ></Button>
            </Box>
          </Grid>
          <Grid item>
            <CustomButton onClick={() => navigate(`/app-vcoi/vcoisitecontent/VcoiAddNewEntity`)} label='+ ADD NEW ENTITY' />
          </Grid>
        </Grid>
        <Box sx={{ overflowX: "auto", width: "100%" }}> {/* Enables scrolling per row */}
        <Box sx={{ minWidth: "600px"}}> {/* Ensures content is structured */}
        <Grid container spacing={2} my={2} alignItems='flex-start' sx={{ fontWeight: 'bold', color: " Gray"}}>
          <Grid item xs={1} sm={1} md={1}>
            ID
          </Grid>
          <Grid item xs={2} sm={2} md={2}>
            HFM CODE
          </Grid>
          <Grid item xs={3} sm={3} md={3}>
            ENTITY NAME
          </Grid>
          <Grid item xs={3} sm={3} md={3}>
            CREATED DATE
          </Grid>
          <Grid item xs={1} sm={1} md={1}>
            IN USE
          </Grid>
          <Grid item xs={2} sm={2} md={2}></Grid>
        </Grid>
        <Divider/>
 {/* Ensures content is properly structured */}
 {currentItems.length > 0 ? (
  currentItems.map((item, index) => ( <React.Fragment key={item.ID || index}>
        <Grid  container alignItems="center" spacing={2} sx={{ padding: "10px 0px" }}>
          {/* ID */}
          <Grid item xs={1} sm={1} md={1}>
            <Typography>{item.ID}</Typography>
          </Grid>

          {/* HFM CODE */}
          <Grid item xs={2} sm={2} md={2}>
            <Typography>{item.EntityName}</Typography>
          </Grid>

          {/* ENTITY NAME */}
          <Grid item xs={3} sm={3} md={3}>
           
            <Typography>{item.EntityDescription}</Typography>
          </Grid>

          {/* CREATED DATE */}
          <Grid item xs={3} sm={3} md={3}>
           
            <Typography>
              {new Date(item.CreatedTime).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }).replace(',', '')}
            </Typography>
          </Grid>

          {/* IN USE */}
          <Grid item xs={1} sm={1} md={1}>
            
            <Typography>{item.InUse===1 ? <CheckIcon color="success" /> : ""}</Typography>
          </Grid>

          {/* Actions - Desktop */}
          <Grid item xs={2} sm={2} md={2} sx={{ display: { xs: "none", sm: "none", md: "flex" }, justifyContent: "right" }}>
            {item.InUse===0 && (
              <Button className="actionButton" variant="contained" startIcon={<DeleteIcon className="actionIcon" />}
                onClick={() => {
                  setItemID(item.ID);
                  setDeleteModel(!deleteModel);
                }}
              >
                Delete
              </Button>
            )}
            &nbsp;&nbsp;
            <Button className="actionButton" variant="contained" startIcon={<EditIcon className="actionIcon" />}
              onClick={() => navigate('/app-vcoi/vcoisitecontent/VcoiAddNewEntity', { state: { EntityData: item } })}
            >
              Edit
            </Button>
          </Grid>

          {/* Actions - Mobile */}
          <Grid item xs={2} sm={2} md={2} sx={{ display: { xs: "flex", sm: "flex", md: "none" }, justifyContent: "right" }}>
            {item.InUse===0 && (
              <DeleteIcon className="actionIconResponsive"
                onClick={() => {
                  setItemID(item.ID);
                  setDeleteModel(!deleteModel);
                }}
              />
            )}
            &nbsp;&nbsp;
            <EditIcon className="actionIconResponsive"
              onClick={() => navigate('/app-vcoi/vcoisitecontent/VcoiAddNewEntity', { state: { EntityData: item } })}
            />
          </Grid>
        </Grid>
      <Divider />
      </React.Fragment>))
) : (
  !inProgress && currentItems.length === 0 && (
    <Box sx={{ margin: "20px", textAlign: "center", color: " Gray", fontStyle: "italic" }}>
      No Data Found...
    </Box>
  )
)}
</Box>
</Box>


        {/* Pagination for filtered items */}
        {filteredItems.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Pagination showFirstButton showLastButton sx={{
              margin: "10px", padding: "5px", border: "1px solid  #212129",
              borderRadius: "20px"
            }} count={Math.ceil(filteredItems.length / itemsPerPage)} page={currentPage} onChange={handlePageChange} /></Box>
        )}
      </Box>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default ManageEntity;
